import { render, staticRenderFns } from "./colour_test.vue?vue&type=template&id=0c7d6316&"
import script from "./colour_test.vue?vue&type=script&lang=js&"
export * from "./colour_test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports